// extracted by mini-css-extract-plugin
export var filterIncDec = "_3i-0";
export var leftBorder = "_3i-1";
export var rightBorder = "_3i-2";
export var stringInput = "_3i-3";